import { z } from 'zod';

import { TrainerOnboardingSocialMediaValidationDto } from './onboarding';

// F4b — org-scoped trainer/member profile, filled on TRAINER/OWNER invite
// acceptance (or later via the member-profile edit page). `socialMedia`
// reuses the existing trainer-onboarding social media validator — those
// rows aren't stored on this entity, they're the existing
// (organizationId, userId)-scoped SocialMedia rows (see BE service).
export const UpdateOrganizationMemberProfileDto = z
  .object({
    description: z
      .string()
      .max(2000, 'VALIDATION__Max2000CharLimit')
      .nullable()
      .optional(),
    workplaces: z
      .array(z.string().min(1).max(255, 'VALIDATION__Max255CharLimit'))
      .max(20)
      .optional(),
    locations: z
      .array(z.string().min(1).max(255, 'VALIDATION__Max255CharLimit'))
      .max(20)
      .optional(),
    expertiseTagIds: z.array(z.string().uuid()).max(50).optional(),
    socialMedia: TrainerOnboardingSocialMediaValidationDto.optional(),
  })
  .strict();

export type ApiUpdateOrganizationMemberProfileDto = z.infer<
  typeof UpdateOrganizationMemberProfileDto
>;
